import { gql, TypedDocumentNode } from 'urql';
import {
  IAddShippingCompany,
  IFindDriverResponse,
  IFindShippingCompanyResponse,
  INewShippingCompany,
  IUpdateShippingCompany,
} from '../interfaces/ShippingCompany';

const ShippingCompanyQueries = {
  listShippingCompanies: (): TypedDocumentNode<
    { shippingCompanies: IFindShippingCompanyResponse[] },
    { where?: { document_number_cnpj: { equals: string } } }
  > => gql`
    query listShippingCompanies($where: ShippingCompanyWhereInput!) {
      shippingCompanies: ListShippingCompanies(where: $where) {
        shippingCompanyId: id
        email: email
        tradeName: trade_name
        companyName: company_name
        phoneNumber: phone_number
        documentNumberCnpj: document_number_cnpj
      }
    }
  `,

  findDriver: (): TypedDocumentNode<
    { driver: IFindDriverResponse },
    { where: { document_number_cpf: { equals: string } } }
  > => gql`
    query getDriver($where: DriverWhereUniqueInput!) {
      driver: GetDriver(where: $where) {
        id
        driver: name
        driverDocument: document_number_cpf
        vehicle: vehicle_model
        vehicleId: vehicle_id
        licensePlate: vehicle_license_plate
        phoneNumber: phone_number
        email
        driverObservation: note
      }
    }
  `,

  addNewShippingCompany: (): TypedDocumentNode<{
    data: IAddShippingCompany;
    newShippingCompany: { id: string };
  }> => gql`
    mutation CreateShippingCompany(
      $data: ShippingCompanyUncheckedCreateInput!
    ) {
      newShippingCompany: CreateShippingCompany(data: $data) {
        id
      }
    }
  `,

  updateShippingCompany: (): TypedDocumentNode<
    { update: { id: string } },
    { where: { id: string }; input: IUpdateShippingCompany }
  > => gql`
    mutation UpdateShippingCompany(
      $where: ShippingCompanyWhereUniqueInput!
      $input: ShippingCompanyUncheckedUpdateInput!
    ) {
      update: UpdateShippingCompany(where: $where, input: $input) {
        id
      }
    }
  `,
};

export default ShippingCompanyQueries;
